import { User } from 'src/app/shared/models/user.model';

export enum Provider {
  'JIBNIT' = 'JIBIT',
  'VADNAR' = 'VANDAR'
}

export class WithdrawTreasury {
  userId: number;
  amount: number;
  status!: 'PENDING' | 'CHECKED_BY_OPERATOR' | 'SUCCESSFUL' | 'ERROR';
  provider!: Provider;
  fee: number;
  createdAt: string;
  iban: string;

  constructor(input: any = {}) {
    this.userId = input.user_id;
    this.provider = input.provider ?? Provider.JIBNIT;
    this.status = input.status;
    this.amount = Math.round(input.amount / 10);
    this.fee = Math.round(input.fee / 10);
    this.createdAt = input.created_at;
    this.iban = input.iban;
  }
}
